// packages/web/src/lib/catalog/preferences.ts
// User catalog preferences management

import { getCachedUserCatalog, isUserCatalogCacheValid, setCachedUserCatalog } from './cache';

/**
 * Get user's active catalog preference from API
 */
export async function getUserActiveCatalogId(): Promise<string | null> {
  if (typeof window === 'undefined') {
    return null; // SSR safe
  }

  // Check cache first
  const cacheKey = 'user-active-catalog';
  if (isUserCatalogCacheValid(cacheKey)) {
    return getCachedUserCatalog(cacheKey);
  }

  try {
    // Import the authenticated API function dynamically to avoid circular imports
    const { apiFetch } = await import('../api');

    const data = await apiFetch('/api/marketplace/customers/catalogs', { method: 'GET' });

    const activeCatalogId = data.preferences?.active_catalog_id;

    if (activeCatalogId) {
      // Cache the result
      setCachedUserCatalog(cacheKey, activeCatalogId);
      return activeCatalogId;
    } else {
      return null;
    }
  } catch (error: any) {
    if (error.status === 401) {
      // User not authenticated, return null
      return null;
    } else {
      console.warn(
        '[CATALOG-PREFERENCES] Failed to fetch user catalog preferences:',
        error.message || error,
      );
      return null;
    }
  }
}

/**
 * Check if user has authentication tokens available
 */
export function hasAuthTokens(): boolean {
  if (typeof window === 'undefined') return false;

  return !!(
    localStorage.getItem('token') ||
    localStorage.getItem('faang_token') ||
    document.cookie.includes('token=') ||
    document.cookie.includes('faang_token=')
  );
}
